import React, { useState } from 'react';
import { Card, CardHeader, Box, Divider, Grid, Button } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloseIcon from '@material-ui/icons/Close';
import {
  FilterChip,
  QuickSearch,
  useAPI,
  VerticalBoxContainer,
} from '@shared/components';
import ExcelExportButton from '../../../../components/ExcelExportButton';
import axios from '../../../../utils/axios';
import getChipValue from '../../../../utils/getChipValue';
import { handleChipDelete } from '../../../../utils/filterHelpers';
import { handleSortChange, getSortDirection } from '../../../../utils/sortHelpers';
import List from './Table';
import Filter from './Filter';

const tableColumns = [
  {
    name: 'Akcija',
    value: 'action',
    align: 'left',
    required: true,
    width: 150,
    placeholder: 'akciji',
  },
  {
    name: 'Korisnik',
    value: 'createdBy',
    align: 'left',
    required: true,
    width: 150,
    placeholder: 'korisniku',
  },
  {
    name: 'Datum',
    value: 'actionDate',
    align: 'left',
    required: true,
    width: 150,
    placeholder: 'datumu',
  },
  {
    name: 'Opis',
    value: 'description',
    align: 'left',
    required: true,
    width: 150,
    placeholder: 'opisu',
  },
];

const exportFields = [
  {
    label: 'ID',
    value: 'id',
  },
  {
    label: 'Dokument ID',
    value: 'subjectId',
  },
  {
    label: 'Akcija',
    value: 'action',
  },
  {
    label: 'Korisnik',
    value: 'createdBy',
  },
  {
    label: 'Datum',
    value: 'actionDate',
    type: 'dateTime'
  },
  {
    label: 'Opis',
    value: 'description',
  },
];

const getLabelText = (value) => {
  const map = {
    action: 'Akcija',
    createdBy: 'Korisnik',
    actionDate: 'Datum',
    description: 'Opis',
  };
  return map[value];
};

const SubjectHistory = ({ subjectId }) => {
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({});
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sorters, setSorters] = useState([]);
  const [triggerRerender] = useState(false);

  const [subjectHistory = { nodes: [], totalCount: 0 }, error, loading] = useAPI(
    () =>
      axios
        .get(`subject/${subjectId}/history`, {
          params: {
            limit: rowsPerPage,
            offset: page * rowsPerPage,
            conditions: filters,
            orderBy: [...sorters, '"id" desc'],
          },
        })
        .then(({ data }) => data),
    [page, rowsPerPage, filters, sorters, triggerRerender],
  );

  return (
    <VerticalBoxContainer>
      <Filter
        currentValues={filters}
        visible={filterModalVisible}
        setVisible={setFilterModalVisible}
        setFilters={setFilters}
        setPage={setPage}
        getLabelText={getLabelText}
      />
      <Box width='100%'>
        <Card>
          <CardHeader
            title={
              <QuickSearch
                name="action"
                placeholder="Brza pretraga po akciji"
                setFilters={setFilters}
                mainFilter={filters}
                setPage={setPage}
              />
            }
            action={
              <Grid container spacing={4}>
                <Grid item>
                  <Button
                    color="primary"
                    disabled={Object.keys(filters).filter((k) => filters[k])?.length === 0}
                    startIcon={<CloseIcon fontSize="small" />}
                    onClick={() => setFilters({})}
                  >
                    <Box fontSize="small">Ukloni sve filtere</Box>
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<FilterListIcon fontSize="small" />}
                    onClick={() => setFilterModalVisible(true)}
                  >
                    <Box fontSize="small">Filteri</Box>
                  </Button>
                </Grid>
                <Grid item>
                  <ExcelExportButton
                    totalCount={subjectHistory.totalCount}
                    sortById={false}
                    variant="outlined"
                    fields={exportFields}
                    sorters={[...sorters, '"id" desc']}
                    filters={filters}
                    routeName={`subject/${subjectId}/history`}
                    fileName={`historija-predmeta-${subjectId}`}
                  />
                </Grid>
              </Grid>
            }
          />
          <Divider />
          {Object.keys(filters).filter((k) => filters[k])?.length !== 0 && (
            <>
              <Box ml={2} p={2} display="flex" alignItems="center" flexWrap="wrap">
                {Object.keys(filters).map(
                  (chip) =>
                    filters[chip] !== undefined && (
                      <FilterChip
                        color="primary"
                        variant="outlined"
                        key={chip}
                        label={`${getLabelText(chip)}: ${getChipValue(chip, filters)}`}
                        onDelete={() => handleChipDelete(chip, setFilters, setPage)}
                      />
                    ),
                )}
              </Box>
            </>
          )}
          <List
            loading={loading}
            error={error}
            subjectHistory={subjectHistory.nodes}
            tableColumns={tableColumns}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalCount={subjectHistory.totalCount}
            handleSortChange={handleSortChange}
            getSortDirection={getSortDirection}
            setSorters={setSorters}
            sorters={sorters}
          />
        </Card>
      </Box>
    </VerticalBoxContainer>
  );
};

export default SubjectHistory;
